import {
  // UsersThree,
  Gear,
  CopySimple,
  Bell,
  // House,
  BellRinging,
  // ClockCounterClockwise,
  LineSegments,
} from "@phosphor-icons/react"
import { useContext, useEffect, useState } from "react"
import { useLocation, useParams } from "react-router-dom"
import DisplayContext from "../../../ReactContexts/DisplayContext"
import AuthContext from "../../../ReactContexts/AuthContext"
import "./WalkAppHeader.css"
import { backendWriter } from "../../App"
// import { sendUsFeedbackEmail } from "../../../SendEmail"
import PostContext from "../../../ReactContexts/PostContext"

const WalkAppHeader = () => {
  const [copied, setCopied] = useState(false)
  const [personName, setPersonName] = useState("") // new state variable for person's name
  const { appView, setAppView } = useContext(DisplayContext)
  const { person } = useContext(AuthContext)
  const { sectionCounts } = useContext(PostContext)

  const { community } = useParams()
  const location = useLocation()
  const handleCopy = async () => {
    const url = window.location.origin + location.pathname
    await navigator.clipboard.writeText(url)
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }

  useEffect(() => {
    const fetchOwnerName = async () => {
      const authorInfo = await backendWriter.getAuthorInfo(community)
      if (authorInfo[community]) {
        setPersonName(authorInfo[community].personName)
      }
    }

    fetchOwnerName()
  }, [community])

  return (
    <div className="walk-header">
      <div className="walk-header-owner-text-container">
        {personName ? `WalkSpace for ${personName}'s friends` : ""}
      </div>
      <div className="walk-header-icon-container">
        <div
          title="Your wild walk."
          onClick={() => {
            setAppView("walk")
          }}
        >
          <LineSegments size={24} weight={appView === "walk" ? "fill" : undefined} />
          &emsp;
        </div>
        {/* <div
          title="IDEA: see past Walks, condensed. (Click to learn more.)"
          style={{ opacity: true ? 0.5 : 1 }}
          onClick={() => {
            // setAppView("past-walks")
            const response = window.prompt(
              "PAST-WALKS (an idea): \n\nSee all of your past Walks, each condensed with an auto-generated title.\n\n How does that sound?"
            )
            if (response) {
              sendUsFeedbackEmail(
                backendWriter.personName,
                response,
                backendWriter.personEmail,
                "PAST WALKS"
              )
              window.alert("Your response was sent to us--thank you!")
            }
          }}
        >
          <ClockCounterClockwise size={24} weight={appView === "walk" ? "fill" : undefined} />
          &emsp;
        </div> */}
        <div
          title="Replies!"
          onClick={() => {
            //move pages
            setAppView("notifications")
            return
          }}
        >
          {sectionCounts?.notifications?.unseen > 0 ? (
            <>
              <BellRinging size={24} weight={appView === "notifications" ? "fill" : "bold"} />
            </>
          ) : (
            <Bell size={24} weight={appView === "notifications" ? "fill" : undefined} />
          )}
          <span style={{ fontSize: ".8em", fontWeight: "bold" }}>
            {sectionCounts?.notifications?.unseen > 0 ? sectionCounts?.notifications?.unseen : ""}
          </span>
          &emsp;
        </div>
        {copied && <span className="walk-header-icon-text fadeout">Link Copied!</span>}
        {person.uid === community ? (
          <>
            <CopySimple size={24} onClick={handleCopy} />
            &emsp;
          </>
        ) : (
          <></>
        )}
        {/* <div
          style={{ opacity: true || appView === "people" ? 0.5 : 1 }}
          title="IDEA: see your Walking Partners. (Click to see more + offer feedback.)"
          onClick={() => {
            //Explain what this is going to be, then ask people how they feel about that.
            //Send us email js feedback, better than aggregating
            const response = window.prompt(
              "WALK-PARTNERS (an idea): see everyone with whom your Walks have overlapped.\n\n What do you think?"
            )
            if (response) {
              sendUsFeedbackEmail(
                backendWriter.personName,
                response,
                backendWriter.personEmail,
                "Walk Partners"
              )
              window.alert("Your response was sent to us--thank you!")
            }
          }}
        >
          <UsersThree size={24} />
          &emsp;
        </div> */}
        <Gear
          size={24}
          onClick={() => setAppView("settings")}
          weight={appView === "settings" ? "fill" : undefined}
        />{" "}
        &emsp;
      </div>
    </div>
  )
}

export default WalkAppHeader
